import { Text } from '@kanda-libs/ks-design-library';

import { JobKandaQuoteLineItem } from './helpers';
import useJobQuoteItemKanda from './useJobQuoteItemKanda';

export interface JobQuoteItemKandaProps extends JobKandaQuoteLineItem {
  index: number;
  isLoading: boolean;
  compact: boolean;
}

const JobQuoteItemKanda: React.FunctionComponent<JobQuoteItemKandaProps> =
  function ({ title, price, description, index, isLoading, compact = false }) {
    const { amount, titleClassName, amountClassName, descriptionClassName } =
      useJobQuoteItemKanda(price, compact);
    return (
      <>
        {index !== 0 && (
          <div className="border-b border-neutral-200 col-span-2" />
        )}
        <Text
          className={titleClassName}
          isLoading={isLoading}
          text={title}
          skeletonProps={{
            width: '100%',
            className: 'max-w-[min(90%,200px)]',
          }}
        />
        <Text
          className={amountClassName}
          isLoading={isLoading}
          text={amount}
          skeletonProps={{
            width: 80,
          }}
        />
        {description && (
          <Text
            className={descriptionClassName}
            isLoading={isLoading}
            text={description}
          />
        )}
      </>
    );
  };

export default JobQuoteItemKanda;
